//const url = "http://pedidosapp.ddns.net:5002/api";
//const url = "http://192.168.15.68:5002/api";
//const url = "http://localhost:5002/api";
//const url = "https://localhost:5001/api";
//const url = "http://192.168.15.254:5002/api";

//Servidor produção local
//const url = "https://gatewaysistemas-app.ddns.net:4443/GwayProducao/api";

//Teste em (homologação)
//const url = "https://vps52074.publiccloud.com.br/apihomologacao/api";

//Produção
const url = "https://vps52074.publiccloud.com.br/apiproducao/api";

export default url;
